import(/* webpackMode: "eager" */ "/frontend/src/app/[lang]/[currency]/(chrome)/faq/page.tsx")